import { CareerPathsSection, StaticCareerPathsSectionProps } from './career-paths-section';
import { CourseCollectionsSection, StaticCourseCollectionsSectionProps } from './course-collections-section';
import { RecommendedProgramsSection, StaticRecommendedProgramsSectionProps } from './recommended-programs-section';
import { SchoolFaqsSection, StaticSchoolFaqsSectionProps } from './school-faqs-section';
import { SchoolHeroSection, StaticSchoolHeroSectionProps } from './school-hero-section';
import {
  SchoolIndustryLeadersSection,
  StaticSchoolIndustryLeadersSectionProps,
} from './school-industry-leaders-section';
import { SchoolLibrarySection, StaticSchoolLibrarySectionProps } from './school-library-section';
import { SchoolTestimonialsSection, StaticSchoolTestimonialsSectionProps } from './school-testimonials-section';

export type SchoolLandingPageProps = {
  staticSchoolHeroSectionProps: StaticSchoolHeroSectionProps;
  staticCourseCollectionsSectionProps: StaticCourseCollectionsSectionProps;
  staticRecommendedProgramsSectionProps: StaticRecommendedProgramsSectionProps;
  staticCareerPathsSectionProps: StaticCareerPathsSectionProps;
  staticSchoolFaqsSectionProps: StaticSchoolFaqsSectionProps;
  staticSchoolIndustryLeadersSectionProps: StaticSchoolIndustryLeadersSectionProps;
  staticSchoolTestimonialsSectionProps: StaticSchoolTestimonialsSectionProps;
  staticSchoolLibrarySectionProps: StaticSchoolLibrarySectionProps;
};

export function SchoolLandingPage({
  staticSchoolHeroSectionProps,
  staticCourseCollectionsSectionProps,
  staticRecommendedProgramsSectionProps,
  staticCareerPathsSectionProps,
  staticSchoolFaqsSectionProps,
  staticSchoolIndustryLeadersSectionProps,
  staticSchoolTestimonialsSectionProps,
  staticSchoolLibrarySectionProps,
}: SchoolLandingPageProps) {
  return (
    <>
      <SchoolHeroSection {...staticSchoolHeroSectionProps} />
      {staticCourseCollectionsSectionProps && <CourseCollectionsSection {...staticCourseCollectionsSectionProps} />}
      {staticRecommendedProgramsSectionProps && (
        <RecommendedProgramsSection {...staticRecommendedProgramsSectionProps} />
      )}
      {staticCareerPathsSectionProps && <CareerPathsSection {...staticCareerPathsSectionProps} />}
      {staticSchoolFaqsSectionProps && <SchoolFaqsSection {...staticSchoolFaqsSectionProps} />}
      {staticSchoolIndustryLeadersSectionProps && (
        <SchoolIndustryLeadersSection {...staticSchoolIndustryLeadersSectionProps} />
      )}
      {staticSchoolTestimonialsSectionProps && <SchoolTestimonialsSection {...staticSchoolTestimonialsSectionProps} />}
      {staticSchoolLibrarySectionProps && <SchoolLibrarySection {...staticSchoolLibrarySectionProps} />}
    </>
  );
}
